import React from 'react';

import { Grid, IconButton, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';

import { ReactComponent as Pharmaplan } from '@pharmaplan/common/assets/icons/pharmaplanText.svg';
import { ReactComponent as Logo } from '@pharmaplan/common/assets/icons/bigLogo.svg';
import ServiceHandler from '@pharmaplan/common/helpers/ServiceHandler';
import { ServiceTypes } from '@pharmaplan/common';

import { ReactComponent as PharmagapAppIcon } from '../../../assets/svg/pharmagapAppIcon.svg';
import strings from '../../../localization';
import { useAppDispatch } from '../../../hooks/useAppDispatch';
import { resetDialog } from '../../../reducers/dialogReducer';
import CustomButton from '../../common/CustomButton';

import classes from './styles';

interface IApproval {
  showCalendlyBooking?: boolean;
  showCloseButton: boolean;
}

const { self, full } = ServiceTypes;

const ApprovalModal: React.FC<IApproval> = ({
  showCalendlyBooking = false,
  showCloseButton,
}) => {
  const dispatch = useAppDispatch();
  const calendlySupportUrl = process.env.REACT_APP_CALENDLY_SUPPORT_URL;

  const service = ServiceHandler.getService();
  const isSelfService = service === self;

  const handleClose = () =>
    dispatch(resetDialog());

  const handleBookSupportSession = () => {
    if (calendlySupportUrl) {
      window.open(calendlySupportUrl, '_blank', 'noopener,noreferrer');
    }
  };

  const iconConfig = {
    [self]: {
      upper: <PharmagapAppIcon />,
      bottom: <Typography sx={classes.title}>{strings.pharmagap}</Typography>,
    },
    [full]: {
      upper: <Logo />,
      bottom: <Pharmaplan />,
    },
  };

  const { upper, bottom } = iconConfig[service] ?? {};

  return (
    <>
      {showCloseButton && (
        <Grid sx={classes.closeContainer}>
          <IconButton size="small" sx={classes.closeIcon} onClick={handleClose}>
            <Close />
          </IconButton>
        </Grid>
      )}
      <Grid sx={[classes.container, showCalendlyBooking && { px: 6 }]} spacing={isSelfService ? 1 : 2} container>
        <>
          <Grid item>{upper}</Grid>
          <Grid item>{bottom}</Grid>
        </>
        <Grid item>
          <Typography sx={classes.text}>
            {showCalendlyBooking
              ? strings.manualProfessionalSignupPendingActivation
              : strings.thankyouRegistration}
          </Typography>
        </Grid>
        {showCalendlyBooking && calendlySupportUrl && (
          <Grid item>
            <CustomButton
              label={strings.bookCalendlySession}
              type="button"
              onClick={handleBookSupportSession}
            />
          </Grid>
        )}
      </Grid>
    </>
  );
};
export default ApprovalModal;
